import axios from "axios";
import { Asset, AssetGeoLocation } from "../models/asset";
import { useRioPlansCache } from "../hooks/useAssets";
import { fetchAssetsPlans } from "../api/fetchAssets";
import { useEffect, useState } from "react";

interface IDealershipAddress {
  address: string;
  neighborhood: string;
  city: string;
  state: string;
}

export const getGeoLocationByAddress = async (
  address: string
): Promise<AssetGeoLocation> => {
  const apiKey = import.meta.env.VITE_HERE_MAPS_API_KEY;
  const url = `https://geocode.search.hereapi.com/v1/geocode?q=${encodeURIComponent(
    address
  )}&apiKey=${apiKey}`;

  try {
    const response = await axios(url);
    const data = response.data;

    if (data.items && data.items.length > 0) {
      const location = data.items[0].position;

      return { lat: location.lat, lng: location.lng };
    } else {
      console.log("Nenhuma localização encontrada para o endereço.");
      return { lat: 0, lng: 0 };
    }
  } catch (error) {
    console.error("Erro ao buscar geolocalização:", error);
    return { lat: 0, lng: 0 };
  }
};

export const getAddressByGeoLocation = async (
  lat?: number,
  lng?: number
): Promise<IDealershipAddress> => {
  if (!lat || !lng)
    return { address: "", neighborhood: "", city: "", state: "" };

  const apiKey = import.meta.env.VITE_HERE_MAPS_API_KEY;
  const url = `https://revgeocode.search.hereapi.com/v1/revgeocode?at=${lat},${lng}&apiKey=${apiKey}`;

  try {
    const response = await axios(url);
    const data = response.data;

    if (data.items && data.items.length > 0) {
      const address = data.items[0].address;

      return {
        address: address.street,
        neighborhood: address.district,
        city: address.city,
        state: address.stateCode,
      };
    } else {
      console.log("Nenhum endereço encontrado para a localização.");
      return { address: "", neighborhood: "", city: "", state: "" };
    }
  } catch (error) {
    console.error("Erro ao buscar endereço:", error);
    return { address: "", neighborhood: "", city: "", state: "" };
  }
};

export const getUptimeAsset = (
  asset: Asset,
  uptimeAssest: Asset[]
): Asset | undefined => {
  const found = uptimeAssest.find((u) => u.chassis === asset.chassis);
  return found;
};

export const assetHasMetrics = (
  asset: Asset,
  uptimeAssests: Asset[]
): boolean => {
  if (asset.odometer && asset.hourmeter) return true;

  const foundAsset = getUptimeAsset(asset, uptimeAssests);
  if (
    (foundAsset?.odometer && foundAsset?.hourmeter) ||
    (foundAsset?.odometer && asset.hourmeter) ||
    (asset.odometer && foundAsset?.hourmeter)
  )
    return true;

  return false;
};

export const assetHasOneMetric = (
  asset: Asset,
  uptimeAssests: Asset[]
): boolean => {
  if (asset.odometer || asset.hourmeter) return true;

  const foundAsset = getUptimeAsset(asset, uptimeAssests);
  return !!(foundAsset?.odometer || foundAsset?.hourmeter);
};

export const getAssetRioPlan = (assetId: string) => {

  const [plans, setPlans] = useState<string>('Carregando...');

  useEffect(() => {
    const fetchPlans = async () => {
      const plans = [];
      const cache = useRioPlansCache.getState().cache;

      if (Object.keys(cache).length === 0) {
        const plans = await fetchAssetsPlans([assetId]);
        setPlans(plans?.map(plan => plan.plan.map(plan => plan.name).filter(Boolean).join(', ')).filter(Boolean).join(', ') ?? '');
      } else {
        for (const [cacheKey, cachedData] of Object.entries(cache)) {
          if (!useRioPlansCache.getState().isCacheValid(cacheKey)) continue;
          const plansData = cachedData.data;
          for (const [planName, assetIds] of Object.entries(plansData)) {
            if (assetIds.includes(assetId)) plans.push(planName);
          }
        }
        setPlans(plans.join(', '));
      }
    };

    fetchPlans();
  }, [assetId]);

  return { plans };
};